import React from 'react';
import { CopyableField } from '../../copyable-field';
import './get-update-payment-method-link.scss';

interface Props {
  updatePaymentMethodLink: string;
  title?: string;
  stacked?: boolean;
  jiraMarkupLabel?: string;
  basicLinkLabel?: string;
  jiraMarkupValuePrefix?: string;
}

export const GetUpdatePaymentMethodLink = ({
  updatePaymentMethodLink,
  title,
  stacked = false,
  jiraMarkupLabel = 'Includes Jira markup e.g. [link title|http://example.com]',
  jiraMarkupValuePrefix = 'Add a credit card to your account',
  basicLinkLabel = 'Basic Link',
}: Props) => {
  const [selectedField, setSelectedField] = React.useState<string>();
  return (
    <div
      className={`update-payment-method-container ${stacked ? 'stacked' : ''}`}
      data-testid="update-payment-method-container"
    >
      {title && <h2>{title}</h2>}
      <div className="copyable-field-container">
        <CopyableField
          autoSelect={true}
          label={jiraMarkupLabel}
          value={`[${jiraMarkupValuePrefix}|${updatePaymentMethodLink}]`}
          buttonSpacing="compact"
          className={selectedField === 'textarea-1' ? 'copyable-button' : ''}
          onBtnClick={() => setSelectedField('textarea-1')}
          testId="copy-field-1"
        />
      </div>
      <div className="copyable-field-container">
        <CopyableField
          autoSelect={false}
          label={basicLinkLabel}
          value={updatePaymentMethodLink}
          buttonSpacing="compact"
          className={selectedField === 'textarea-2' ? 'copyable-button' : ''}
          onBtnClick={() => setSelectedField('textarea-2')}
          testId="copy-field-2"
        />
      </div>
    </div>
  );
};
